import mapboxgl from 'mapbox-gl';

export const removeLayerIfExists = (map: mapboxgl.Map, layerId: string) => {
  if (map.getLayer(layerId)) {
    map.removeLayer(layerId);
  }
};

export const removeLayersIfExists = (map: mapboxgl.Map, layerIds: string[]) => {
  layerIds.forEach(layerId => {
    removeLayerIfExists(map, layerId);
  });
};

export const removeSourceIfExists = (map: mapboxgl.Map, sourceId: string) => {
  if (map.getSource(sourceId)) {
    map.removeSource(sourceId);
  }
};

export const removeSourcesIfExists = (map: mapboxgl.Map, sourceIds: string[]) => {
  sourceIds.forEach(sourceId => {
    removeSourceIfExists(map, sourceId);
  });
};

export const removeImageIfExists = (map: mapboxgl.Map, image: string) => {
  if (map.hasImage(image)) {
    map.removeImage(image);
  }
};

export const removeImagesIfExists = (map: mapboxgl.Map, images: string[]): void => {
  images.forEach(image => {
    removeImageIfExists(map, image);
  });
};
